import { AnyAction } from '@reduxjs/toolkit';
import { Dispatch } from 'react';
import { setCompany, setUserInfo } from 'store/User/actions/user';
import { JwtPayload, jwtDecode } from 'jwt-decode';
import { IUserData } from 'store/User/types';

export const decodeTokenAndSetUserData = (
  accessToken: string,
  dispatch: Dispatch<AnyAction>
) => {
  const decodedToken: any = jwtDecode<JwtPayload>(accessToken);
  if (!decodedToken?.sub) {
    alert('Error decoding token');
    return;
  }
  const userData: IUserData = {
    id: decodedToken.sub.id,
    email: decodedToken.sub.email,
    first_name: decodedToken.sub.first_name,
    last_name: decodedToken.sub.last_name,
    is_admin: decodedToken.sub.is_admin,
    permissions: decodedToken.sub.permissions,
  };
  dispatch(setUserInfo(userData));
  dispatch(setCompany(decodedToken.sub.selected_company));

  return decodedToken.sub.selected_company;
};
